import {
	TIME_ZONES,
	FORM_TIMEZONE_TYPES
} from "constants.js";
import { find } from "lodash";
import moment from "moment";

class TimezoneService {
	constructor(appState) {
		this.appState = appState;
	}

	getConfiguredTimezoneCode(entity) {
		if(this.appState.forms.selected.TimeMode.Code === FORM_TIMEZONE_TYPES.ByEntity) {
			const entityTimeZoneCode = (
				entity?.TimeZone
				|| entity?.primary?.TimeZone
				|| entity?.friendly?.TimeZone
			)?.Code;
			if(entityTimeZoneCode)	
				return ({ 
					exact: true,
					source: FORM_TIMEZONE_TYPES.ByEntity,
					timeZoneCode: entityTimeZoneCode,
					timeZoneAbbr: this.getTimezoneByIANACode(entityTimeZoneCode).name
				});
		} else if(this.appState.forms.selected.TimeMode.Code == FORM_TIMEZONE_TYPES.ByUser) {
			const userTimeZoneCode = moment.tz.guess();
			if(userTimeZoneCode)	
				return ({ 
					exact: true,
					source: FORM_TIMEZONE_TYPES.ByUser,
					timeZoneCode: userTimeZoneCode,
					timeZoneAbbr: this.getTimezoneByIANACode(userTimeZoneCode).name
				});
		}

		return ({
			exact: this.appState.forms.selected.TimeMode.Code === FORM_TIMEZONE_TYPES.ByForm,
			source: FORM_TIMEZONE_TYPES.ByForm,
			timeZoneCode: this.appState.forms.selected.TimeZone.Code,
			timeZoneAbbr: this.getTimezoneByIANACode(this.appState.forms.selected.TimeZone.Code).name
		});
	}

	getTimezoneByIANACode(code) {
		const ianaTZ = find(TIME_ZONES, z => z.ianaCode === code);
		return ianaTZ;
	}
}

export default angular
	.module("vesl.services.timezone-service", [])
	.service("timezoneService", TimezoneService).name;
